
/* eslint-disable react/no-array-index-key */

import React from 'react';
import './FourBoxLoading.css'; // External CSS for styling
import CardSkeleton from './CardSkeleton';

const FourBoxLoading = () => {
  return (
    <div className="loading-grid">
      {[...Array(4)].map((_, index) => (
        <div key={index} className="loading-box">
          {/* <div className="spinner"></div> */}
          <CardSkeleton />
        </div>
      ))}
    </div>
  );
};

export default FourBoxLoading;
